// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
        '.print-only': {
          display: 'none !important',
        },
        '@media print': {
          '@page': {
            size: 'auto',
            margin: '10mm 8mm',
          },
          '*, *::before, *::after': {
            WebkitPrintColorAdjust: 'exact !important',
            printColorAdjust: 'exact !important',
          },
          'header, nav, aside, .no-print, .print-hide, .MuiDrawer-root, .MuiAppBar-root, .MuiBackdrop-root, .MuiDialog-root, .MuiTabs-root, .MuiPagination-root, .MuiTablePagination-root, button:not(.allow-print), .MuiButton-root:not(.allow-print), .MuiIconButton-root:not(.allow-print), .MuiFab-root, .MuiSpeedDial-root, .print-hide-action': {
            display: 'none !important',
            visibility: 'hidden !important',
          },
          '.print-only': {
            display: 'block !important',
            visibility: 'visible !important',
          },
          'html, body, #root': {
            margin: '0 !important',
            padding: '0 !important',
            width: '100% !important',
            minWidth: '100% !important',
            maxWidth: '100% !important',
            height: 'auto !important',
            minHeight: 'auto !important',
            overflow: 'visible !important',
            backgroundColor: '#ffffff !important',
            color: '#000000 !important',
          },
          'main, .MuiContainer-root': {
            margin: '0 !important',
            padding: '0 !important',
            width: '100% !important',
            minWidth: '100% !important',
            maxWidth: '100% !important',
            height: 'auto !important',
            minHeight: 'auto !important',
            overflow: 'visible !important',
            boxShadow: 'none !important',
            backgroundColor: '#ffffff !important',
          },
          '.MuiPaper-root': {
            boxShadow: 'none !important',
            border: 'none !important',
            overflow: 'visible !important',
            backgroundColor: 'transparent !important',
          },
          '.MuiTableContainer-root': {
            overflow: 'visible !important',
            width: '100% !important',
            maxWidth: '100% !important',
            minWidth: '0 !important',
          },
          'table, .MuiTable-root': {
            width: '100% !important',
            minWidth: '100% !important',
            maxWidth: '100% !important',
            borderCollapse: 'collapse !important',
            pageBreakInside: 'auto !important',
            tableLayout: 'auto !important',
          },
          'thead, .MuiTableHead-root': {
            display: 'table-header-group !important',
          },
          'tr, .MuiTableRow-root': {
            pageBreakInside: 'avoid !important',
            breakInside: 'avoid !important',
          },
          'th, td, .MuiTableCell-root': {
            border: '1px solid #CBD5E1 !important',
            padding: '6px 8px !important',
            fontSize: '9.5pt !important',
            lineHeight: '1.3 !important',
            color: '#0F172A !important',
          },
          'th, .MuiTableCell-head': {
            backgroundColor: '#F1F5F9 !important',
            color: '#0B3B60 !important',
            fontWeight: '700 !important',
          },
        },
      }}
    />
  );

  return inputGlobalStyles;
}
